import React from 'react'
import {connect} from 'react-redux'

import showModal from './data/actions/show_modal'

const GroupChatsSeeAllLink = (props) => {
  const {classes, style, showModal, children} = props

  return (
    <a className={classes} style={style} href='#' onClick={showModal}>
      {children}
    </a>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    showModal: (e) => {
      if (e && e.preventDefault) e.preventDefault()

      dispatch(showModal({type: 'groupChats', props: {}}))
    }
  }
}

const GroupChatsSeeAllLinkContainer = connect(
  null, mapDispatchToProps
)(GroupChatsSeeAllLink)

export default GroupChatsSeeAllLinkContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/group_chats_see_all_link.js
 **/